//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import qAuStatusInfo from "@/components/Generics/qAuStatusInfo.vue";
import { mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import membersListInfo from "@/components/tasks/membersListInfo/membersListInfo.vue";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import {
    copyToClipboard,
    convertAndFormatTimeToLocal
} from "@/assets/js/appFunc";

export default {
    components: {
        AQModal,
        AQTooltip,
        AQCard,
        membersListInfo,
        qAuStatusInfo,
        AQButton,
        AQMenu,
        AQDialog,
        AQChip,
        AQBadge
    },
    props: {
        message: {
            type: Object,
            default: () => {}
        },
        instanceName: {
            type: String,
            default: ""
        },
        instanceStatus: {
            type: String,
            default: ""
        },
        id: {
            type: String,
            default: ""
        },
        processInspectorMessagesModal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            APP_DATE_DOT_FORMAT,
            readonly: true,
            openModal: this.processInspectorMessagesModal,
            afterCopyButtonTrace: [{ icon: "file_copy", handler: () => { copyToClipboard(); } }],
            error: true,
            messageSummary: {},
            formattedObj: [],
            recipientsFormattedObj: [],
            showPopup: [],
            openDialog: false,
            optionsMenuError: [
                {
                    value: "copy",
                    label: this.$t("admin.processInspector.copy")
                },
                {
                    value: "download",
                    label: this.$t("admin.processInspector.download")
                }
            ],
            headerActionsModal: [{
                label: this.$t("generic.delete"),
                value: "delete",
                itemDisabled: this.checkStatus()
            }]

        };
    },
    computed: {
        getChipColor() {
            return this.formattedObj[0].type === "dataModels" ? "recipient-style-name-datamodel" : "recipient-style-name-rest";
        },
        getMessageBody() {
            let renderedMessage = this.$refs.renderedBody;
            if (this.messageSummary && this.messageSummary.body) {
                renderedMessage.innerHTML = this.messageSummary.body;
            } else {
                renderedMessage = this.$t("admin.processInspector.notAvailable");
            }
            document.querySelectorAll("section").forEach(elem => {
                elem.setAttribute("contenteditable", false);
            });
            return renderedMessage;
        },
        title() {
            const typeMess = this.message.notificationType === "SMS" ? this.message.notificationType : this.message.notificationType.toLowerCase();
            return this.$t("admin.processInspector.deleteTitleNotification", { type: typeMess });
        }

    },
    mounted() {
        this.getMessageSummary(this.message.notificationAuditId).then(data => {
            this.messageSummary = data.data;
            const targetNotif = this.messageSummary.targetNotification;
            if (targetNotif) {
                ["dataModels", "groups", "plainText", "users"].forEach(type => {
                    (targetNotif[type] || [])
                        .forEach(user => this.formattedObj.push({
                            name: type === "users" ? user.username : user, status: user.userStatus || "", email: user.email || "", type
                        }));
                });
            }
        });
        if (this.message) {
            ["users", "plainText"].forEach(type => {
                (this.message[type] || []).forEach(user => this.recipientsFormattedObj.push({ name: type === "users" ? user.username : user,
                    status: user.userStatus || "",
                    email: user.email || "",
                    type }));
            });
        }
    },
    methods: {
        convertAndFormatTimeToLocal,
        ...mapActions("admin", ["getMessageSummary", "deleteNotification"]),
        actionsDlg($event) {
            if ($event === "close") {
                this.$emit("closeProcessInformationMessagesModal");
                this.$emit("input");
            } else if ($event === this.$t("generic.delete")) {
                this.openDialog = true;
            }
        },
        getActivityIcon(item) {
            let iconToShow = null;
            let { activityType } = item;
            if (activityType === "APPROVALLEVEL_PLUGIN") {
                activityType = "APPROVAL_PLUGIN";
            }
            if (item && item.connectorName && activityType === "GENERAL_START_PLUGIN") {
                iconToShow = require("@/assets/images/ActivitiesIcons/syncfusion/leftPanel/GENERAL_START_PLUGIN.svg");
            } else if (item && this.messageSummary.relatedToType && item.connectorName && item.connectorName !== "Untitled connector") {
                iconToShow = require(`@/assets/images/ActivitiesIcons/syncfusion/leftPanel/${this.messageSummary.relatedToType}.svg`);
            } else if (item && (!item.connectorName || item.connectorName === "Untitled connector")) {
                iconToShow = require(`@/assets/images/ActivitiesIcons/syncfusion/leftPanel/${activityType}.svg`);
            }
            return iconToShow;
        },
        optionSelected(evt) {
            if (evt[0].value === "copy") {
                this.copyError();
            } else if (evt[0].value === "download") {
                this.downloadErrorCode(this.messageSummary.error);
            }
        },
        getChipProps(details) {
            const { status, type, name, email } = details;
            let typeToReturn = "default";
            if (type === "users") {
                typeToReturn = status === "DISABLED" ? "disabledUser" : "user";
            } else if (type === "groups") {
                typeToReturn = "group";
            } else if (type === "dataModels") {
                typeToReturn = "m_datamodel";
            }
            return {
                type: typeToReturn,
                fromInnerMenu: true,
                content: type === "users" ? (name || email) : name
            };
        },
        editorInit(editorInstance) {
            editorInstance.setReadOnly("true");
        },
        addMsgBgColor(value) {
            return value === "SMS" ? "background-color: #00CC66" : "background-color: #4285F4";
        },
        downloadErrorCode(data) {
            const fileType = "text/plain";
            const blob = new Blob([data], { type: fileType });
            const a = document.createElement("a");
            const fileName = "Error";
            const url = URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        },
        copyError() {
            copyToClipboard(this.messageSummary.error);
        },
        copyTraceId() {
            copyToClipboard(this.messageSummary.traceId);
        },
        okAction() {
            this.deleteNotification(this.id).then(data => {
                this.$emit("closeProcessInformationMessagesModal");
                this.$emit("messageDelete", data.data);
                this.$toast.showNotify({
                    type: "success",
                    message: this.$t("admin.processInspector.deleteSuccessfully", { type: data.data.notificationType, activity: data.data.activityName }),
                    timeout: 500
                });
            });
        },
        cancelAction() {
            this.openDialog = false;
        },
        checkStatus() {
            let disabledOpt = false;
            if (this.instanceStatus === "RUNNING" || this.instanceStatus === "FAILED") {
                disabledOpt = true;
            }
            return disabledOpt;
        }

    }

};
